/* eslint-disable prettier/prettier */
import styled from '@mui/system/styled';
import { colors } from 'components/theme/constants';

export const StepperDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& .stepItem': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .stepCounterCont': {
      display: 'flex',
      alignItems: 'center',
      '& .stepCounter': {
        height: 20,
        width: 20,
        borderRadius: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.white,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.04)',
        gap: '10px',
        border: '1px solid #E0E0E0',
        '& p': {
          fontSize: 10,
          fontWeight: 400,
          lineHeight: '16px',
          color: '#616161',
        },
      },
      '& .stepBar': {
        width: 30,
        marginRight: 10,
        marginTop: 3,
        borderTop: '1px dashed #BDBDBD',
      },
    },
    '& .counterActive': {
      '& .stepCounter': {
        backgroundColor: colors.primary.main,
        border: 'unset',
        '& p': {
          color: colors.white,
        },
      },
      '& body1': {
        color: '#232750',
      },
    },
    '& .counterSelected': {
      '& .stepCounter': {
        backgroundColor: '#4CAF50',
        border: 'unset',
        '& p': {
          color: '#232750!important',
        },
      },
      '& .stepBar': {
        border: '1px solid #4CAF50',
      },
      '& body1': {
        color: '#232750',
      },
    },
    '& body1': {
      margin: '0px 10px 0px 5px',
      color: '#616161',
      fontSize: 11,
      fontWeight: 500,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
    },
    '& .labelActive': {
      '& body1': {
        color: colors.primary.main,
      },
    },
    '& .labelSelected': {
      '& body1': {
        color: '#2E7D32',
        fontWeight: 500,
      },
    },
  },
});
